import {
    FormControlLabel,
    Checkbox,
    Typography
  } from "@mui/material";

const CheckboxWrapper = ({
    name, 
    label,
    checked, 
    onChange, 
    variant,
    color = 'primary'
}) => {

    return(
        <FormControlLabel
            label={
                variant
                ? (<Typography variant={variant}>
                        {label}
                    </Typography>)
                : label
            }
            control={
                <Checkbox
                    checked={checked}
                    onChange={onChange}
                    name={name}
                    color={color}
                    inputProps={{
                        ...name && { "data-testid": `${name}Checkbox` }
                    }}
                />
            }
        />
    )

}

export default CheckboxWrapper;